module.exports = __webpack_public_path__ + "static/media/texto_3.f453b7ca.png";